import { useTranslation } from "react-i18next";
import { colorMaterials, currCanopy, currStem, currVariation, getERPcolorByCode, getERPparameterIDByColor } from "./MyFunctions";
import "./styles/BottomBar.css"
import ReceiptIcon from '@mui/icons-material/Receipt';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import LightSharpIcon from '@mui/icons-material/LightSharp';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import i18n from "./i18n";
import axios from "axios";
import { useEffect, useState } from "react";

// const productURL = "https://stage.luminaire-authentik.leeroy.codes/api/cart";
// const productURL = "https://lapreprod.ca/api/cart";
const productURL = "https://www.luminaireauthentik.com/api/cart";
// const productURL = "http://localhost:4000/api";

function BottomBar({ print, data, currModel, filtered, mtl, cart, setCart, setCartVisible, makeCode, isRequired, setPreSubmit, erpLink, currParameters, setCurrParameters, erpProducts, forceUpdate, currency, iframe, thumb, setThumb }) {
    const { t } = useTranslation();
    const [productID, setProductID] = useState(null);
    const [newPrice, setNewPrice] = useState();
    const [params, setParams] = useState([]);

    // console.log(currModel);

    function findProductByID(id) {
        // console.log(erpProducts)
        var rtn;
        for (let p of erpProducts) {
            // console.log(p)
            if (p.id === id) {
                rtn = p;
            }
        }
        return rtn;
    }


    function getERPprice(params) {
        const goodCurr = currency.toLowerCase() === "usd" ? 1 : 2;
        axios.post(
            erpLink + "erp/price",
            {
                "geography_id": goodCurr,
                "params": params,
                "productID": productID,
            }
        )
            .then(res => {
                // Transform data from ERP to Edge data
                // const erp = res.data.data;
                // console.log(res.data, params, productID);
                setNewPrice(res.data.price)
            })
            .catch(error => {
                console.error('Error fetching ERP price:', error);
            });
    }


    useEffect(() => {
        // console.log(currModel)
        // console.log(currModel?.build?.data?.dataERP?.parameters, currModel?.lampshade?.data?.dataERP?.parameters);
        if (currModel?.build?.id && currModel?.lampshade?.id) {
            const buildErp = currModel.build.data.dataERP?.products;
            const lampErp = currModel.lampshade.data.dataERP?.name;
            // console.log(buildErp)
            if (buildErp && lampErp) {
                for (let p of buildErp) {
                    for (let r of p.recipes) {
                        if (r.name === lampErp) {
                            setProductID(p.id);
                            // console.log(p.id,findProductByID(p.id));
                            setCurrParameters(findProductByID(p.id).params);
                        }
                    }
                }
            }
        }
    }, [currModel]);

    useEffect(() => {
        if (currModel.build.id && currModel.lampshade.id) {
            if (currParameters?.length > 0) {
                // console.log(currParameters);
                var tmp = [];
                var tmpLeeroy = [];
                const tmpParams = [...currModel.build.data.dataERP.params, ...currModel.lampshade.data.dataERP.params]
                for (let curr of currParameters) {
                    var valID = curr.default;
                    var isChanged = false;
                    const newMtl = Object.fromEntries(
                        Object.entries(colorMaterials.curr).filter(([key]) => mtl.includes(key))
                    );
                    for (let currMtl of Object.values(newMtl)) {
                        if (curr.id === currMtl?.parameter_id) {
                            if (currMtl.code === "SAME_EXT") {
                                const colEXT = getERPcolorByCode(data.colors, colorMaterials.curr.exterior?.code)
                                const parID = getERPparameterIDByColor(tmpParams.find(e => e.id === curr.id)?.values, colEXT.id);
                                // console.log(parID)
                                currMtl.parameter_value_id = parID || colorMaterials.default.exterior?.parameter_value_id;
                            } else if (currMtl.code === "SAME_STEM") {
                                const colEXT = getERPcolorByCode(data.colors, colorMaterials.curr.stem?.code)
                                const parID = getERPparameterIDByColor(tmpParams.find(e => e.id === curr.id)?.values, colEXT.id);
                                // console.log(parID)
                                currMtl.parameter_value_id = parID || colorMaterials.default.stem?.parameter_value_id;
                            }
                            // console.log(currMtl);
                            if (currMtl.parameter_value_id) {
                                valID = currMtl.parameter_value_id;
                                isChanged = true;
                            }
                        }
                    }
                    // console.log(currCanopy.data, curr.id)
                    if (currCanopy?.data?.parameter_id === curr.id) {
                        valID = currCanopy.data.parameter_value_id;
                        isChanged = true;
                    }
                    if (currStem?.data?.parameter_id === curr.id) {
                        valID = currStem.data.parameter_value_id;
                        isChanged = true;
                    }
                    if (isChanged) {
                        tmp.push({ "parameter_id": curr.id, "parameter_value_id": valID })
                    }
                }
                // const test = { "products": [{ "product_id": 77, "product_qty": 1, "parameters": [{ "parameter_id": 1, "parameter_value_id": 216 }] }] }
                tmpLeeroy = { "products": [{ product_id: productID, product_qty: 1, parameters: tmp }] }
                // console.log(tmp)
                // console.log(colorMaterials.curr.exterior)
                getERPprice(tmp)
                setParams(tmpLeeroy);


            } else {
                setNewPrice()
            }
        } else {
            setNewPrice()
        }
    }, [currParameters, forceUpdate, currModel, mtl, currCanopy]);

    useEffect(() => {
        if (thumb) {
            // console.log(thumb)            
            productPage()
        }
    }, [thumb]);

    async function productPage() {

        // const username = 'leeroy';
        // const password = 'gaspe-501';
        // const toek = btoa(`${username}:${password}`);
        // let toek = "bGVlcm95Omdhc3BlLTUwMQ==";
        const req = Object.values(isRequired);
        // console.log(req)
        if (!req.includes(false)) {
            // Crée un nouveau formulaire
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = productURL;

            const inputs = () => {
                var arr = [];
                // console.log(params.products[0].parameters)
                for (let [i, p] of params.products[0].parameters.entries()) {
                    for (let [i2, p2] of Object.entries(p)) {
                        arr.push({ name: `products[0][parameters][${i}][${i2}]`, value: p2 })
                    }
                }
                return [
                    { name: 'products[0][product_id]', value: params.products[0].product_id },
                    { name: 'products[0][product_qty]', value: params.products[0].product_qty },
                    { name: 'products[0][product_thumb]', value: thumb },
                    ...arr
                ]
            }

            inputs().forEach(inputData => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = inputData.name;
                input.value = inputData.value;
                form.appendChild(input);
            });

            // // Ajoute le formulaire au document et le soumet
            document.body.appendChild(form);
            form.submit();
            // console.log(form)



            setThumb();

        } else {
            setPreSubmit(true);
            setThumb();
        }
    }

    function findColor(code) {
        var c = '';
        data.colors.map((color) => {
            if (color.code === code) {
                c = color
            }
            return false
        })
        return c;
    }

    function addToCart_old() {
        const req = Object.values(isRequired);
        if (!req.includes(false)) {
            setPreSubmit(false);
            setCartVisible(true);
            makeCode();
            var build = {
                name: currModel.build.model,
                title: currModel.build.title,
                // price: 0,
                // numOfHead: mutiplier(),
                materials: []
            }
            var lampshade = {
                name: currModel.lampshade.model,
                title: currModel.lampshade.title,
                // price: 0,
                materials: []
            }
            Object.entries(colorMaterials.curr).forEach(entry => {
                const [key, value] = entry;
                // console.log(value)
                if (mtl.includes(key)) {
                    if (key.includes('wire') || key.includes('base') || key.includes('hardware') || key.includes('stem') || key.includes('canopy')) {
                        const color = findColor(value.code);
                        build.materials.push({ type: key, code: value.code, hex: color.hex, name: { en: color.name_en, fr: color.name_fr } });
                    } else {
                        var tmp = key;

                        const color = findColor(value.code);
                        if (key === "glass") {
                            tmp = "glassType"
                        } else if (key === "glassint") {
                            tmp = "glassColor"
                        }
                        lampshade.materials.push({ type: tmp, code: value.code, hex: color.dataERP?.color || color.hex, name: { en: color.dataERP?.name?.en || color.name_en, fr: color.dataERP?.name?.fr || color.name_fr } });
                    }
                }
            });

            //console.log({build:build,lampshade:lampshade});
            setCart({ ...cart, build: build, lampshade: lampshade })
        } else {
            setPreSubmit(true);
        }
    }


    return (
        <div id="bottombar">
            <div id='price'>
                {newPrice ? <p id="totalPrice">{(Math.round(newPrice * 100) / 100).toFixed(2) + "$"}</p> : <p className="small" id="totalPrice">{t("noPrice")}</p>}
            </div>
            {!newPrice ? <div className="bottomIcon" onClick={() => addToCart_old()} id="addtocart_old">
                <ReceiptIcon />
                <p >{t("submission")}</p>
            </div>
                :
                <div className="bottomIcon" onClick={() => iframe.contentWindow.postMessage({ getThumbnail: { x: 225, y: 225 }, })} id="addtocart">
                    <AddShoppingCartIcon />
                    <p >{t("addToCart")}</p>
                </div>
            }
            {/* <button onClick={() => o.print()} className="export3d"><p>{t("export3d")}</p><span></span></button> */}
            <div className="bottomIcon" onClick={() => print()} id="export3d">
                <IosShareOutlinedIcon />
                {/* <span className="icon"></span> */}
                <p >{t("export3d")}</p>
            </div>
            {/* <div className="bottomIcon" onClick={() => window.open(sampleKit, "_blank")} id="samplekit">
                <span className="icon"></span>
                <p >{t("sampleKit")}</p>
            </div> */}
            {/* <button onClick={() => goTo()}>GOTO</button> */}


            {/* { "products": [{ "product_id": 77, "product_qty": 1, "parameters": [{ "parameter_id": 1, "parameter_value_id": 216 }] }] } */}
            {/* <form id="productForm" action={productURL} method="POST">
                <input type="hidden" name="products[0][product_id]" value="77" />
                <input type="hidden" name="products[0][product_qty]" value="1" />
                <input type="hidden" name="products[0][parameters][0][parameter_id]" value="1" />
                <input type="hidden" name="products[0][parameters][0][parameter_value_id]" value="216" />
                <button type="submit">Envoyer</button>
                </form> */}

            {/* <form method="POST" id="productForm" action="https://stage.luminaire-authentik.leeroy.codes/api/cart">
                <input type="hidden" name="products[0][product_id]" value="149" />
                <input type="hidden" name="products[0][product_qty]" value="1" />
                <input type="hidden" name="products[0][parameters][0][parameter_id]" value="9" />
                <input type="hidden" name="products[0][parameters][0][parameter_value_id]" value="213" />
                <input type="hidden" name="products[0][parameters][1][parameter_id]" value="11" />
                <input type="hidden" name="products[0][parameters][1][parameter_value_id]" value="898" />
                <input type="hidden" name="products[0][parameters][2][parameter_id]" value="18" />
                <input type="hidden" name="products[0][parameters][2][parameter_value_id]" value="1837" />
                <button type="submit">Envoyer</button>
            </form> */}


        </div>
    );
}
export default BottomBar;

